/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Devine formula: for men, 50 kg plus 2.3 kg for every inch over 5 feet tall; for women, 45.5 kg plus 2.3 kg per inch over 5 feet. It's a widely used estimate originally developed for medical dosing, not a precise health measurement.`)
};

const es_hw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fórmula de Devine: para hombres, 50 kg más 2,3 kg por cada pulgada sobre 5 pies; para mujeres, 45,5 kg más 2,3 kg por pulgada sobre 5 pies. Es una estimación ampliamente utilizada originalmente desarrollada para dosificación médica, no una medición de salud precisa.`)
};

const de_hw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Devine-Formel: für Männer 50 kg plus 2,3 kg für jeden Zoll über 5 Fuß groß; für Frauen 45,5 kg plus 2,3 kg pro Zoll über 5 Fuß. Es ist eine weit verbreitete Schätzung, die ursprünglich für medizinische Dosierung entwickelt wurde, keine präzise Gesundheitsmessung.`)
};

const nl_hw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De Devine-formule: voor mannen 50 kg plus 2,3 kg voor elke inch boven 5 voet; voor vrouwen 45,5 kg plus 2,3 kg per inch boven 5 voet. Het is een veel gebruikte schatting die oorspronkelijk voor medische dosering werd ontwikkeld, niet een precieze gezondheidsmeting.`)
};

const fr_hw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La formule de Devine : pour les hommes, 50 kg plus 2,3 kg pour chaque pouce au-dessus de 5 pieds ; pour les femmes, 45,5 kg plus 2,3 kg par pouce au-dessus de 5 pieds. C'est une estimation largement utilisée initialement développée pour le dosage médical, pas une mesure de santé précise.`)
};

const it_hw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La formula di Devine: per gli uomini, 50 kg più 2,3 kg per ogni pollice sopra i 5 piedi; per le donne, 45,5 kg più 2,3 kg per pollice sopra i 5 piedi. È una stima ampiamente utilizzata originariamente sviluppata per il dosaggio medico, non una misurazione di salute precisa.`)
};

const pt_br2_hw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A fórmula de Devine: para homens, 50 kg mais 2,3 kg para cada polegada acima de 5 pés de altura; para mulheres, 45,5 kg mais 2,3 kg por polegada acima de 5 pés. É uma estimativa amplamente usada originalmente desenvolvida para dosagem médica, não uma medida precisa de saúde.`)
};

const pt_hw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A fórmula de Devine: para homens, 50 kg mais 2,3 kg por cada polegada acima de 5 pés de altura; para mulheres, 45,5 kg mais 2,3 kg por polegada acima de 5 pés. É uma estimativa amplamente utilizada originalmente desenvolvida para dosagem médica, não uma medição de saúde precisa.`)
};

const ja_hw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devine公式：男性の場合、50kg（5フィートを超えるインチあたり2.3kg）。女性の場合、45.5kg（5フィートを超えるインチあたり2.3kg）。これは医学的投与量計画のために元々開発された広く使用されている推定値であり、正確な健康測定ではありません。`)
};

const zh_hw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devine 公式：男性为 50 千克，加上超出 5 英尺身高部分每英寸 2.3 千克；女性为 45.5 千克，加上超出 5 英尺部分每英寸 2.3 千克。这是一种被广泛使用的估算方法，最初是为医疗给药剂量而开发，并非精确的健康测量指标。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hw_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hw_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hw_faq3_a", locale)
	if (locale === "en") return en_hw_faq3_a(inputs)
	if (locale === "es") return es_hw_faq3_a(inputs)
	if (locale === "de") return de_hw_faq3_a(inputs)
	if (locale === "nl") return nl_hw_faq3_a(inputs)
	if (locale === "fr") return fr_hw_faq3_a(inputs)
	if (locale === "it") return it_hw_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_hw_faq3_a(inputs)
	if (locale === "pt") return pt_hw_faq3_a(inputs)
	if (locale === "ja") return ja_hw_faq3_a(inputs)
	return zh_hw_faq3_a(inputs)
};